// @ts-nocheck
/**
 * encodedStringSelect.ts — Parse/build encoded stringSelect values.
 *
 * Format: `${selected}${separator}${option1}${separator}${option2}...`
 * Index 0 is the selected value; indices 1..n are all selectable options.
 */

export const DEFAULT_ENCODED_STRING_SELECT_SEPARATOR = ';';

export interface ParsedEncodedStringSelect {
  readonly selected: string;
  readonly options: readonly string[];
}

function resolveSeparator(separator?: string): string {
  if (separator === undefined || separator === '') {
    return DEFAULT_ENCODED_STRING_SELECT_SEPARATOR;
  }
  return separator;
}

/** Decode an encoded stringSelect bound value. */
export function parseEncodedStringSelect(
  raw: unknown,
  separator?: string,
): ParsedEncodedStringSelect {
  if (raw === null || raw === undefined) {
    return { selected: '', options: [] };
  }
  const str = String(raw);
  if (str.length === 0) {
    return { selected: '', options: [] };
  }
  const delim = resolveSeparator(separator);
  const parts = str.split(delim);
  const selected = parts[0] ?? '';
  const options = parts.length > 1 ? parts.slice(1) : [];
  return { selected, options };
}

/** Encode selected value and options into a bound stringSelect value. */
export function buildEncodedStringSelect(
  selected: string,
  options: readonly string[],
  separator?: string,
): string {
  const delim = resolveSeparator(separator);
  if (options.length === 0) {
    return String(selected);
  }
  return [String(selected), ...options.map((opt) => String(opt))].join(delim);
}
